module.exports = __webpack_public_path__ + "img/explain.6695ade2.svg";